<form [formGroup]="printForm">
    <div class="print-form">
        <div class="print-form__left">
            <label class="print-form__label">{{ 'PAGE.ANALYSIS.PRINT_PARAMS.DEFINE_PRINT_CONTENT.LBL' | translate }}:</label>
            <div
                *ngFor="let option of printOptions"
                class="print-form__left--content">
                <sera-checkbox
                    [label]="option.name | translate"
                    [inputId]="option.key"
                    [isDisabled]="option.key === 'coverSheet'"
                    [formControlName]="option.key"
                    (stateChanged)="checkboxParentChanged($event, option)">
                </sera-checkbox>
                <div
                    *ngIf="option.hasSubOption"
                    class="print-form__left__sub">
                    <sera-checkbox
                        *ngFor="let subOption of option.subOption"
                        [label]="subOption.name | translate"
                        [inputId]="subOption.key"
                        [formControlName]="subOption.key"
                        (stateChanged)="checkboxChildChanged($event, option, subOption)">
                    </sera-checkbox>
                </div>
            </div>
        </div>

        <div class="print-form__right">
            <label class="print-form__label">{{ 'PAGE.ANALYSIS.PRINT_PARAMS.MULTIPLE_MERKMALE.LBL' | translate }}:</label>
            <sera-radio-button
                formControlName="multipleFeatures"
                [options]="multipleCriteriaOptions">
            </sera-radio-button>
        </div>
    </div>
</form>
<div class="sera-popup-footer">
    <ds-button
        [variant]="'ghost'"
        (click)="closeDialog()"
        (keydown.enter)="closeDialog()">
        {{ 'PAGE.GENERAL.CLOSE.BT' | translate }}
    </ds-button>
    <ds-button
        ds-loading
        [variant]="'primary'"
        [isLoading]="($selectLoadingPrintAnalysis | async)!"
        (click)="print()"
        (keydown.enter)="print()">
        {{ 'PAGE.GENERAL.PRINT.LBL' | translate }}
    </ds-button>
</div>
